import { c as _c } from "react/compiler-runtime";
import { useProjectLearningOutcomes } from '@openclassrooms/data-connect-web/learning-content';
import LearningOutcomeListItem from '../LearningOutcomeListItem';
export function ProjectLearningOutcomeListItems(t0) {
  const $ = _c(9);
  const {
    className: t1,
    projectId
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== projectId) {
    t2 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: t3
  } = useProjectLearningOutcomes(t2);
  let t4;
  if ($[2] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const learningOutcomes = t4;
  let t5;
  if ($[4] !== learningOutcomes) {
    t5 = learningOutcomes.map(_temp);
    $[4] = learningOutcomes;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== className || $[7] !== t5) {
    t6 = <ul className={className}>{t5}</ul>;
    $[6] = className;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return <LearningOutcomeListItem component="div" key={id} title={name} />;
}
export default ProjectLearningOutcomeListItems;